import { useParams } from 'react-router-dom';
import { RouteParams } from '@/router/type';
import { useGetServerlessProjectById } from '@/service/serverless-gpu/hook';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { toastSomethingError } from '@/components/ui/toast-content';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateServerlessProjectName } from '@/service/serverless-gpu';
import { serverlessKeys } from '@/service/serverless-gpu/hook';

const ChangeName = () => {
  const { projectId } = useParams<RouteParams>();
  const [name, setName] = useState('');
  const queryClient = useQueryClient();

  const { data: dataProject, isLoading } = useGetServerlessProjectById({
    project_id: projectId!,
  });

  const { mutate, isPending } = useMutation({
    mutationFn: updateServerlessProjectName,
    onSuccess: () => {
      toast.success('Project name updated successfully');
      queryClient.invalidateQueries({
        queryKey: serverlessKeys.project({ project_id: projectId! }),
      });
      queryClient.invalidateQueries({ queryKey: serverlessKeys.projects() });
    },
    onError: (error: Error) => {
      if (error?.message?.includes('duplicate key value')) {
        toast.error('Project name already exists.');
        return;
      }
      toastSomethingError();
    },
  });

  useEffect(() => {
    if (dataProject?.project.project_name) {
      setName(dataProject.project.project_name);
    }
  }, [dataProject?.project.project_name]);

  const handleUpdate = () => {
    if (!name.trim()) {
      toast.error('Project name cannot be empty.');
      return;
    }
    mutate({
      project_id: projectId!,
      project_name: name,
    });
  };

  const isSaveDisabled =
    isLoading ||
    isPending ||
    !name ||
    name === dataProject?.project.project_name;

  return (
    <div className="space-y-2">
      <p className="font-semibold">Project Name</p>
      <div className="flex w-fit items-center justify-start space-x-2">
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="min-w-80"
          disabled={isLoading || isPending}
        />
        <Button onClick={handleUpdate} disabled={isSaveDisabled}>
          {'Rename'}
        </Button>
      </div>
    </div>
  );
};

export default ChangeName;
